"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectExtendedResponse = void 0;
const core = __importStar(require("../../core"));
const ProjectExtendedResponseModelTargetAudience_1 = require("./ProjectExtendedResponseModelTargetAudience");
const ProjectState_1 = require("./ProjectState");
const ProjectExtendedResponseModelAccessLevel_1 = require("./ProjectExtendedResponseModelAccessLevel");
const ProjectExtendedResponseModelFiction_1 = require("./ProjectExtendedResponseModelFiction");
const ProjectCreationMetaResponseModel_1 = require("./ProjectCreationMetaResponseModel");
const ProjectExtendedResponseModelSourceType_1 = require("./ProjectExtendedResponseModelSourceType");
const ProjectExtendedResponseModelQualityPreset_1 = require("./ProjectExtendedResponseModelQualityPreset");
const ChapterResponse_1 = require("./ChapterResponse");
const PronunciationDictionaryVersionResponseModel_1 = require("./PronunciationDictionaryVersionResponseModel");
const PronunciationDictionaryLocatorResponseModel_1 = require("./PronunciationDictionaryLocatorResponseModel");
const ProjectExtendedResponseModelApplyTextNormalization_1 = require("./ProjectExtendedResponseModelApplyTextNormalization");
exports.ProjectExtendedResponse = core.serialization.object({
    projectId: core.serialization.property("project_id", core.serialization.string()),
    name: core.serialization.string(),
    createDateUnix: core.serialization.property("create_date_unix", core.serialization.number()),
    defaultTitleVoiceId: core.serialization.property("default_title_voice_id", core.serialization.string()),
    defaultParagraphVoiceId: core.serialization.property("default_paragraph_voice_id", core.serialization.string()),
    defaultModelId: core.serialization.property("default_model_id", core.serialization.string()),
    lastConversionDateUnix: core.serialization.property("last_conversion_date_unix", core.serialization.number().optional()),
    canBeDownloaded: core.serialization.property("can_be_downloaded", core.serialization.boolean()),
    title: core.serialization.string().optional(),
    author: core.serialization.string().optional(),
    description: core.serialization.string().optional(),
    genres: core.serialization.list(core.serialization.string()).optional(),
    coverImageUrl: core.serialization.property("cover_image_url", core.serialization.string().optional()),
    targetAudience: core.serialization.property("target_audience", ProjectExtendedResponseModelTargetAudience_1.ProjectExtendedResponseModelTargetAudience.optional()),
    language: core.serialization.string().optional(),
    contentType: core.serialization.property("content_type", core.serialization.string().optional()),
    originalPublicationDate: core.serialization.property("original_publication_date", core.serialization.string().optional()),
    matureContent: core.serialization.property("mature_content", core.serialization.boolean().optional()),
    isbnNumber: core.serialization.property("isbn_number", core.serialization.string().optional()),
    volumeNormalization: core.serialization.property("volume_normalization", core.serialization.boolean()),
    state: ProjectState_1.ProjectState,
    accessLevel: core.serialization.property("access_level", ProjectExtendedResponseModelAccessLevel_1.ProjectExtendedResponseModelAccessLevel),
    fiction: ProjectExtendedResponseModelFiction_1.ProjectExtendedResponseModelFiction.optional(),
    qualityCheckOn: core.serialization.property("quality_check_on", core.serialization.boolean()),
    qualityCheckOnWhenBulkConvert: core.serialization.property("quality_check_on_when_bulk_convert", core.serialization.boolean()),
    creationMeta: core.serialization.property("creation_meta", ProjectCreationMetaResponseModel_1.ProjectCreationMetaResponseModel.optional()),
    sourceType: core.serialization.property("source_type", ProjectExtendedResponseModelSourceType_1.ProjectExtendedResponseModelSourceType.optional()),
    chaptersEnabled: core.serialization.property("chapters_enabled", core.serialization.boolean().optional()),
    qualityPreset: core.serialization.property("quality_preset", ProjectExtendedResponseModelQualityPreset_1.ProjectExtendedResponseModelQualityPreset),
    chapters: core.serialization.list(ChapterResponse_1.ChapterResponse),
    pronunciationDictionaryVersions: core.serialization.property("pronunciation_dictionary_versions", core.serialization.list(PronunciationDictionaryVersionResponseModel_1.PronunciationDictionaryVersionResponseModel)),
    pronunciationDictionaryLocators: core.serialization.property("pronunciation_dictionary_locators", core.serialization.list(PronunciationDictionaryLocatorResponseModel_1.PronunciationDictionaryLocatorResponseModel)),
    applyTextNormalization: core.serialization.property("apply_text_normalization", ProjectExtendedResponseModelApplyTextNormalization_1.ProjectExtendedResponseModelApplyTextNormalization),
    experimental: core.serialization.record(core.serialization.string(), core.serialization.unknown()).optional(),
});
